import {
  DataCollectionRecord,
  useBirthIndexSearch,
} from '@ltvco/refresh-lib/hooks';
import { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';
import React, { useEffect } from 'react';

interface IBirthIndexesFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setBirthIndexResults: (data: DataCollectionRecord[] | undefined) => void;
}

export const BirthIndexesFetcher = ({
  searchData,
  setBirthIndexResults,
}: IBirthIndexesFetcherProps) => {
  const { birthIndexResults } = useBirthIndexSearch({
    firstName: searchData.fName,
    middleName: searchData.mName,
    lastName: searchData.lName,
    dateOfBirth:
      searchData.birthYear && searchData.birthMonth
        ? `${searchData.birthYear}-${searchData.birthMonth}`
        : undefined,
    state: searchData.state,
    city: searchData.city,
    country: searchData.country,
  });

  useEffect(() => {
    setBirthIndexResults(birthIndexResults);
  }, [birthIndexResults, setBirthIndexResults]);

  return <React.Fragment />;
};
